export function _getUserInfo(){
  return JSON.parse( localStorage.getItem('wonder_user_info') )
}

export function _setUserInfo(userInfo){
  console.info(userInfo)
  localStorage.setItem( 'wonder_user_info',JSON.stringify(userInfo) )
}

// localStorage.setItem( 'wonder_access_token','acb1c2db77a0534db59e3362ce0258c544100004' )
// localStorage.setItem( 'wonder_access_out_time','604799' )
// localStorage.setItem( 'wonder_refresh_token','re153dbc8b0d9c42ad97801b56f9678d41100004' )
// localStorage.setItem( 'wonder_refresh_out_time','1295999' )
// localStorage.setItem( 'wonder_refresh_login_time','1609147870868' )
export function _removeUserInfo(){
  localStorage.removeItem('wonder_user_info')
}

export function _getExplainShow(){
  return localStorage.getItem('wonder_explainShow') | false
}

export function _setExplainShow(explainShow = false){
  localStorage.setItem('wonder_explainShow',explainShow)
}

export function _getToken(){
  return {
    accessToken:localStorage.getItem('wonder_access_token'),
    accessOutTime:localStorage.getItem('wonder_access_out_time'),
    refreshToken:localStorage.getItem('wonder_refresh_token'),
    refreshOutTime:localStorage.getItem('wonder_refresh_out_time'),
    loginTime:localStorage.getItem('wonder_refresh_login_time')
  }
}

export function _setToken(AccessToken,AccessOutTime,RefreshToken,RefreshOutTime,loginTime){
  localStorage.setItem( 'wonder_access_token',AccessToken )
  localStorage.setItem( 'wonder_access_out_time',AccessOutTime )
  localStorage.setItem( 'wonder_refresh_token',RefreshToken )
  localStorage.setItem( 'wonder_refresh_out_time',RefreshOutTime )
  localStorage.setItem( 'wonder_refresh_login_time',loginTime )
}

export function _removeToken(){
  localStorage.removeItem('wonder_access_token')
  localStorage.removeItem('wonder_access_out_time')
  localStorage.removeItem('wonder_refresh_token')
  localStorage.removeItem('wonder_refresh_out_time')
  localStorage.removeItem('wonder_refresh_login_time')
}
